import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { useTranslation } from 'react-i18next';
import { getTermsAndConditions } from 'repos/legalDocuments';
import { getAllMenuPage } from 'repos/menu';

import Layout from 'components/layout';
import RichTextRenderer from 'components/richTextRenderer';
import SEO from 'components/seo';

export default function TermsAndConditionsPage({
  legalDocument,
  menuParams,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { t } = useTranslation();

  return (
    <Layout menuParams={menuParams}>
      <SEO title={t('terms_and_conditions')} />
      <div className="mx-auto mb-12 mt-32 max-w-4xl px-6">
        <RichTextRenderer
          document={legalDocument.fields.content}
          className="prose-sm"
        />
      </div>
    </Layout>
  );
}

export const getStaticProps = async ({ locale }: GetStaticPropsContext) => {
  const legalDocument = await getTermsAndConditions({
    locale,
  });

  const menuParams = await getAllMenuPage({ locale });

  return {
    props: {
      legalDocument,
      menuParams,
    },
  };
};
